import React, { useState, useEffect } from 'react';
import { supabase } from '../utils/supabase';
import Header from '../components/common/Header';
import '../styles/EmailConfirmation.css';

export default function EmailConfirmation() {
  const [showPopup, setShowPopup] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const [loading, setLoading] = useState(true);

  const emailButtons = [
    { id: 1, label: 'Login', path: '/login' },
    { id: 2, label: 'Sign Up', path: '/signup' }
  ];

  useEffect(() => {
    // Check if user is coming back from email verification link
    const checkEmailVerification = async () => {
      try {
        // Check for hash params (Supabase returns tokens in URL hash after email verification)
        const hashParams = new URLSearchParams(window.location.hash.substring(1));
        const accessToken = hashParams.get('access_token');
        const type = hashParams.get('type');

        console.log('Hash params:', { accessToken: !!accessToken, type });

        // If we have an access token and it's an email verification
        if (accessToken && type === 'signup') {
          console.log('Email verification detected from URL - redirecting to success page');
          
          // Redirect to the dedicated success page
          window.location.href = '/email-verification-success' + window.location.hash;
          return;
        }

        // Check for query param (in case of redirect from verification)
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get('verified') === 'true') {
          const { data: { user } } = await supabase.auth.getUser();
          if (user && user.email_confirmed_at) {
            setIsVerified(true);
            setShowPopup(true);
          }
        } else {
          // Check current user session
          const { data: { user } } = await supabase.auth.getUser();
          
          if (user && user.email_confirmed_at) {
            console.log('User already verified:', user.email);
            setIsVerified(true);
          }
        }
      } catch (error) {
        console.error('Error checking verification:', error);
      } finally {
        setLoading(false);
      }
    };

    checkEmailVerification();
  }, []);

  const handleVerifyEmail = () => {
    // This is for manual testing - in production, users click the link in their email
    setShowPopup(true);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
    // Redirect to profile setup after closing popup
    window.location.href = '/profile-setup';
  };

  return (
    <div className="email-confirmation-page">
      <Header buttons={emailButtons} className="email-confirmation-header" />
      <div className="email-confirmation-main">
        <div className="email-confirmation-content">
          {loading ? (
            <div className="email-confirmation-loading">
              <p>Checking verification status...</p>
            </div>
          ) : isVerified ? (
            <div className="email-confirmation-verified">
              <h1 className="email-confirmation-title">✓ Email Verified!</h1>
              <p className="email-confirmation-message">
                Your email has been successfully verified. Click below to continue to profile setup.
              </p>
              <button className="verify-email-button app-btn" onClick={handleClosePopup}>
                Continue to Profile Setup
              </button>
            </div>
          ) : (
              <>
                <h1 className="email-confirmation-title">
                  Check you Email for Verification Link.
                </h1>
                <h1 className="email-confirmation-title">
                  Click on Verify to continue with your profile setup.
                </h1>
                <div className="email-confirmation-message">
                  <p>
                    Congratulations! You have created a new account with ITZ. Click on 
                    <strong> 'Verify email'</strong> in the email we sent you. Then you will be taken back here 
                    to continue with your profile setup.
                  </p>
                  <p>
                    Then, you will fill in your profile so we can customize your learning experience!
                  </p>
                </div>

                <div className="email-confirmation-note">
                  <p>
                    <strong>Note:</strong> Please check your inbox and click the verification link. 
                    After verifying, come back to this website and click the button below to continue.
                  </p>
                </div>
                
                <button className="verify-email-button app-btn" onClick={() => window.location.href = '/profile-setup'}>
                  I've Verified - Continue to Profile Setup
                </button>
              </>
            )}
        </div>
      </div>

      {/* Popup Modal */}
      {showPopup && (
        <div className="verification-popup-overlay">
          <div className="verification-popup">
            <div className="verification-popup-icon">✓</div>
            <h2 className="verification-popup-title">Email Verified Successfully!</h2>
            <p className="verification-popup-message">
              Your email has been confirmed. You can now proceed to set up your profile.
            </p>
            <button className="verification-popup-button app-btn" onClick={handleClosePopup}>
              Continue to Profile Setup
            </button>
          </div>
        </div>
      )}
    </div>
  );
}